import { AlertCircle } from 'lucide-react'
import { cn } from '../../lib/utils'

interface ErrorMessageProps {
  message: string
  onRetry?: () => void
  retryLabel?: string
  className?: string
}

export function ErrorMessage({
  message,
  onRetry,
  retryLabel = 'Opnieuw proberen',
  className = '',
}: ErrorMessageProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-lg border border-red-200 bg-red-50 p-6 text-red-800 dark:border-red-800 dark:bg-red-950/30 dark:text-red-200',
        className
      )}
      role="alert"
    >
      <AlertCircle className="h-10 w-10 shrink-0" />
      <p className="text-center font-medium">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          {retryLabel}
        </button>
      )}
    </div>
  )
}
